<template>
  <div class="edit-mortgage-part-content">
    <a-row :gutter="[16,16]">
      <a-col :span="8">
        <a-card title="Leningdeel">
          <a-form-item :has-feedback="hasFeedback('leningdeelnummer')"
                       :validate-status="hasFeedback('leningdeelnummer') ? 'error' : null"
                       :help="getFeedbackString('leningdeelnummer')"
                       label="Leningdeelnummer">
            <a-input v-model="mortgagePart.leningdeelnummer"
                     @change="deleteError('leningdeelnummer')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('hoofdsom')"
                       :validate-status="hasFeedback('hoofdsom') ? 'error' : null"
                       :help="getFeedbackString('hoofdsom')"
                       label="Hoofdsom">
            <amount-input v-model="mortgagePart.hoofdsom"
                          @change="deleteError('hoofdsom')"
                          name="hoofdsom"
                          class="part-hoofdsom"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('begindatum')"
                       :validate-status="hasFeedback('begindatum') ? 'error' : null"
                       :help="getFeedbackString('begindatum')"
                       label="Begindatum">
            <a-date-picker @change="
                             syncStartDurationEnd(mortgagePart, 'begindatum', 'duur', 'einddatum', 'duration');
                             deleteError('begindatum');
                           "
                           v-model="mortgagePart.begindatum"
                           :format="DateFormatEnum.DISPLAY_DATE"
                           :value-format="DateFormatEnum.DATE"
                           :disabledDate="(current) => {return mortgagePart.einddatum && current.isAfter(mortgagePart.einddatum)}"
                           name="begindatum"
                           class="part-begindatum"
            ></a-date-picker>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('duur')"
                       :validate-status="hasFeedback('duur') ? 'error' : null"
                       :help="getFeedbackString('duur')"
                       label="Looptijd">
            <a-input type="number"
                     @change="
                      syncStartDurationEnd(mortgagePart, 'begindatum', 'duur', 'einddatum', 'end');
                      deleteError('duur');
                     "
                     v-model="mortgagePart.duur"
                     addon-after="Maand(en)"
                     min="0"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('einddatum')"
                       :validate-status="hasFeedback('einddatum') ? 'error' : null"
                       :help="getFeedbackString('einddatum')"
                       label="Einddatum">
            <a-date-picker
                @change="
                  syncStartDurationEnd(mortgagePart, 'begindatum', 'duur', 'einddatum', 'duration');
                  deleteError('einddatum');
                "
                v-model="mortgagePart.einddatum"
                :format="DateFormatEnum.DISPLAY_DATE"
                :value-format="DateFormatEnum.DATE"
                :disabledDate="(current) => {return mortgagePart.begindatum && current.isBefore(mortgagePart.begindatum)}"
                name="einddatum"
                class="part-einddatum"
            ></a-date-picker>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('repayment_type')"
                       :validate-status="hasFeedback('repayment_type') ? 'error' : null"
                       :help="getFeedbackString('repayment_type')"
                       label="Aflosvorm">
            <a-select v-model="mortgagePart.repayment_type" @change="deleteError('repayment_type')"
                      show-search
                      :filter-option="filterOption"
            >
              <a-select-option v-for="(label,key) in enums.repaymentTypes" :key="key" :value="Number(key)">
                {{ label }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('type')"
                       :validate-status="hasFeedback('type') ? 'error' : null"
                       :help="getFeedbackString('type')"
                       label="Type">
            <a-select v-model="mortgagePart.type" @change="deleteError('type')" style="width: 100%;"
                      show-search
                      :filter-option="filterOption"
            >
              <a-select-option v-for="(label,key) in enums.mortgagePartTypes" :key="key" :value="Number(key)">
                {{ label }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('remaining_debt')"
                       :validate-status="hasFeedback('remaining_debt') ? 'error' : null"
                       :help="getFeedbackString('remaining_debt')"
                       label="Restschuld">
            <amount-input v-model="mortgagePart.remaining_debt" @change="deleteError('remaining_debt')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('remaining_debt_date')"
                       :validate-status="hasFeedback('remaining_debt_date') ? 'error' : null"
                       :help="getFeedbackString('remaining_debt_date')"
                       label="Restschulddatum">
            <a-date-picker v-model="mortgagePart.remaining_debt_date"
                           @change="deleteError('remaining_debt_date')"
                           :format="DateFormatEnum.DISPLAY_DATE"
                           :value-format="DateFormatEnum.DATE"
                           show-search
                           :filter-option="filterOption"
            ></a-date-picker>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('remaining_debt_old_age_pension')"
                       :validate-status="hasFeedback('remaining_debt_old_age_pension') ? 'error' : null"
                       :help="getFeedbackString('remaining_debt_old_age_pension')"
                       label="Restschuld op AOW-datum">
            <amount-input v-model="mortgagePart.remaining_debt_old_age_pension"
                          @change="deleteError('remaining_debt_old_age_pension')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('remaining_deb_last_year')"
                       :validate-status="hasFeedback('remaining_deb_last_year') ? 'error' : null"
                       :help="getFeedbackString('remaining_deb_last_year')">
                <span slot="label">
                  Aflosstand per ({{ toDate(enums.remainingDebtLastYearDate, 'D-M-YYYY') }})
                </span>
            <amount-input v-model="mortgagePart.remaining_deb_last_year"
                          @change="deleteError('remaining_deb_last_year')"/>
          </a-form-item>
        </a-card>
      </a-col>

      <a-col :span="8">
        <a-card title="Rente">
          <a-form-item :has-feedback="hasFeedback('rente')"
                       :validate-status="hasFeedback('rente') ? 'error' : null"
                       :help="getFeedbackString('rente')"
                       label="Rentepercentage">
            <percentage-input v-model="mortgagePart.rente" @change="deleteError('rente')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('begindatumRentevast')"
                       :validate-status="hasFeedback('begindatumRentevast') ? 'error' : null"
                       :help="getFeedbackString('begindatumRentevast')"
                       label="Begindatum rentevast"
          >
            <a-date-picker
                @change="
                  syncStartDurationEnd(mortgagePart, 'begindatumRentevast', 'rentevasteperiode', 'einddatumRentevast', 'duration');
                  deleteError('begindatumRentevast');
                "
                v-model="mortgagePart.begindatumRentevast"
                :format="DateFormatEnum.DISPLAY_DATE"
                :value-format="DateFormatEnum.DATE"
                :disabledDate="(current) => {return mortgagePart.einddatumRentevast && current.isAfter(mortgagePart.einddatumRentevast)}"
            ></a-date-picker>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('rentevasteperiode')"
                       :validate-status="hasFeedback('rentevasteperiode') ? 'error' : null"
                       :help="getFeedbackString('rentevasteperiode')"
                       label="Rentevastperiode">
            <a-input type="number"
                     @change="
                      syncStartDurationEnd(mortgagePart, 'begindatumRentevast', 'rentevasteperiode', 'einddatumRentevast', 'end');
                      deleteError('rentevasteperiode');
                     "
                     v-model="mortgagePart.rentevasteperiode"
                     addon-after="Maand(en)"
                     min="0"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('einddatumRentevast')"
                       :validate-status="hasFeedback('einddatumRentevast') ? 'error' : null"
                       :help="getFeedbackString('einddatumRentevast')"
                       label="Einddatum rentevast">
            <a-date-picker
                @change="
                  syncStartDurationEnd(mortgagePart, 'begindatumRentevast', 'rentevasteperiode', 'einddatumRentevast', 'duration');
                  deleteError('einddatumRentevast');
                "
                v-model="mortgagePart.einddatumRentevast"
                :format="DateFormatEnum.DISPLAY_DATE"
                                   :value-format="DateFormatEnum.DATE"
                :disabledDate="(current) => {return mortgagePart.begindatumRentevast && current.isBefore(mortgagePart.begindatumRentevast)}"
            ></a-date-picker>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('company_rate_id')"
                       :validate-status="hasFeedback('company_rate_id') ? 'error' : null"
                       :help="getFeedbackString('company_rate_id')"
                       label="Tariefklasse">
            <a-select v-model="mortgagePart.company_rate_id"
                      @change="deleteError('company_rate_id')"
                      v-if="companyRatesList !== null">
              <a-select-option v-for="(companyRate, key) in companyRatesList" :key="key" :value="key">
                {{ companyRate }}
              </a-select-option>
            </a-select>
            <span v-else>
              Selecteer het product of de geldverstrekker van de hypotheek op de tab "Algemeen"
            </span>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('interest_type')"
                       :validate-status="hasFeedback('interest_type') ? 'error' : null"
                       :help="getFeedbackString('interest_type')"
                       label="Rentetype">
            <a-radio-group v-model="mortgagePart.interest_type"
                           @change="deleteError('interest_type')"
                           button-style="solid">
              <a-radio-button v-for="(value,key) in enums.mortgagePartInterestTypes" :key="key" :value="key">
                {{ value }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('mortgage_guarantee')"
                       :validate-status="hasFeedback('mortgage_guarantee') ? 'error' : null"
                       :help="getFeedbackString('mortgage_guarantee')"
                       label="Garantie type">
            <a-radio-group v-model="mortgagePart.mortgage_guarantee"
                           @change="deleteError('mortgage_guarantee')"
                           button-style="solid" size="small">
              <a-radio-button v-for="(label,key) in enums.mortgagePartMortgageGuarantees" :key="key" :value="key">
                {{ label }}
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-card>
      </a-col>

      <a-col :span="8">
        <a-card title="Fiscaliteit">
          <a-form-item :has-feedback="hasFeedback('tax_box_type')"
                       :validate-status="hasFeedback('tax_box_type') ? 'error' : null"
                       :help="getFeedbackString('tax_box_type')"
                       label="Fiscaliteit">
            <a-radio-group v-model="mortgagePart.tax_box_type"
                           @change="deleteError('tax_box_type')"
                           button-style="solid">
              <a-radio-button :value="1">
                Box 1
              </a-radio-button>
              <a-radio-button :value="3">
                Box 3
              </a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('interest_deduction_end_date')"
                       :validate-status="hasFeedback('interest_deduction_end_date') ? 'error' : null"
                       :help="getFeedbackString('interest_deduction_end_date')"
                       label="Einde renteaftrek">
            <a-date-picker v-model="mortgagePart.interest_deduction_end_date"
                           @change="deleteError('interest_deduction_end_date')"
                           :format="DateFormatEnum.DISPLAY_DATE"
                                   :value-format="DateFormatEnum.DATE"
            ></a-date-picker>
          </a-form-item>
        </a-card>
      </a-col>

      <a-col :span="8" v-if="mortgagePart.is_repayment_type_acount">
        <a-card title="Opbouw">
          <a-form-item :has-feedback="hasFeedback('monthly_deposit')"
                       :validate-status="hasFeedback('monthly_deposit') ? 'error' : null"
                       :help="getFeedbackString('monthly_deposit')"
                       label="Maandelijkse inleg">
            <amount-input v-model="mortgagePart.monthly_deposit" @change="deleteError('monthly_deposit')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('current_value')"
                       :validate-status="hasFeedback('current_value') ? 'error' : null"
                       :help="getFeedbackString('current_value')"
                       label="Actuele waarde">
            <amount-input v-model="mortgagePart.current_value" @change="deleteError('current_value')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('lowest_deposit_any_year')"
                       :validate-status="hasFeedback('lowest_deposit_any_year') ? 'error' : null"
                       :help="getFeedbackString('lowest_deposit_any_year')"
                       label="Laagste storting in enig jaar">
            <amount-input v-model="mortgagePart.lowest_deposit_any_year"
                          @change="deleteError('lowest_deposit_any_year')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('highest_deposit_any_year')"
                       :validate-status="hasFeedback('highest_deposit_any_year') ? 'error' : null"
                       :help="getFeedbackString('highest_deposit_any_year')"
                       label="Hoogste storting in enig jaar">
            <amount-input v-model="mortgagePart.highest_deposit_any_year"
                          @change="deleteError('highest_deposit_any_year')"/>
          </a-form-item>
        </a-card>

        <a-card title="Overig">
          <a-form-item :has-feedback="hasFeedback('penalty_free_repayment_percentage')"
                       :validate-status="hasFeedback('penalty_free_repayment_percentage') ? 'error' : null"
                       :help="getFeedbackString('penalty_free_repayment_percentage')"
                       label="Percentage boetevrijaflossen">
            <percentage-input v-model="mortgagePart.penalty_free_repayment_percentage"
                              @change="deleteError('penalty_free_repayment_percentage')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('transfer_fine_amount')"
                       :validate-status="hasFeedback('transfer_fine_amount') ? 'error' : null"
                       :help="getFeedbackString('transfer_fine_amount')"
                       label="Boeterente bij oversluiten">
            <amount-input v-model="mortgagePart.transfer_fine_amount"
                          @change="deleteError('transfer_fine_amount')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('transfer_fine_amount_date')"
                       :validate-status="hasFeedback('transfer_fine_amount_date') ? 'error' : null"
                       :help="getFeedbackString('transfer_fine_amount_date')"
                       label="Berekeningsdatum boete bij oversluiten">
            <a-date-picker v-model="mortgagePart.transfer_fine_amount_date"
                           @change="deleteError('transfer_fine_amount_date')"
                           :format="DateFormatEnum.DISPLAY_DATE"
                           :value-format="DateFormatEnum.DATE"
            />
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('original_fixed_interest_period_comparison_rate')"
                       :validate-status="hasFeedback('original_fixed_interest_period_comparison_rate') ? 'error' : null"
                       :help="getFeedbackString('original_fixed_interest_period_comparison_rate')"
                       label="Hypotheekrente ORVP">
            <percentage-input v-model="mortgagePart.original_fixed_interest_period_comparison_rate"
                              @change="deleteError('original_fixed_interest_period_comparison_rate')"/>
          </a-form-item>

          <a-form-item :has-feedback="hasFeedback('remaining_fixed_interest_period_comparison_rate')"
                       :validate-status="hasFeedback('remaining_fixed_interest_period_comparison_rate') ? 'error' : null"
                       :help="getFeedbackString('remaining_fixed_interest_period_comparison_rate')"
                       label="Hypotheekrente RRVP">
            <percentage-input v-model="mortgagePart.remaining_fixed_interest_period_comparison_rate"
                              @change="deleteError('remaining_fixed_interest_period_comparison_rate')"/>
          </a-form-item>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="24" style="text-align: right">
        <a-popconfirm
            :title="`Weet je zeker dat je dit leningdeel wilt verwijderen?`"
            ok-text="Ja"
            cancel-text="Nee"
            @confirm="deleteMortgagePartByIndex(mortgagePartIndex)"
            placement="topRight"
        >
          <a-button type="danger">Leningdeel verwijderen</a-button>
          <!--  @click="deleteMortgagePartByIndex(mortgagePartIndex)"  -->
        </a-popconfirm>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {toDate} from "~/plugins/string-helpers";
import show_backend_feedback from "~/modules/mortgage/mixins/show_backend_feedback";
import {DateFormatEnum} from "~/enums";
import syncStartDurationEnd from "~/mixins/syncStartDurationEnd.js";

export default {
  name: "MortgageEditPartComponent",
  props: {
    mortgagePartIndex: Number,
    enums: Object,
    companyRatesList: [Array, Object],
    loading: Boolean
  },
  data() {
    return {
      extraOpen: false,
      toDate: toDate,
      index: this.mortgagePartIndex,
      DateFormatEnum: DateFormatEnum
    }
  },
  mixins: [
    show_backend_feedback,
    syncStartDurationEnd
  ],
  mounted() {
    if (this.mortgageParts[this.mortgagePartIndex] === 'undefined') {
      throw new Error('The given mortgage part index can not be found in the store.');
    }
  },
  methods: {
    filterOption(input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    },
    ...mapActions('mortgage', [
      'deleteMortgagePartByIndex',
    ]),
  },
  computed: {
    ...mapGetters('mortgage', [
      'mortgageParts'
    ]),
    getFeedbackObject() {
      return this.mortgagePart;
    },
    mortgagePart() {
      return this.mortgageParts[this.index];
    },
  }
}
</script>

<style scoped>
.ant-select {
  width: 100%;
}
</style>